import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

// import css from './IconCollection.module.css';

const LOGO = 'logo';
const ICON_SEND = 'IconSend';
const PASSWORD_SHOW_ICON = 'passwordShowIcon';
const CROSS_ICON = 'crossIcon';
const PASSWORD_HIDE_ICON = 'passwordHideIcon';
const ICON_LIKE = 'likeIcon';
const ICON_BAG = 'bagIcon';
const ICON_MANAGE = 'manageIcon';
const ICON_PLUS = 'plusIcon';
const ICON_DELETE = 'deleteIcon';
const ICON_UPLOAD = 'uploadIcon';
const ICON_UPLOAD_INBOX = 'uploadInboxIcon';
const ICON_SETTINGS = 'settingIcon';
const RIGHT_SIDE_ARROW_ICON = 'rightArrowIcon';
const DOWN_ARROW_ICON = 'downArrowIcon';
const ADD_TO_BAG_ICON = 'addToBag';
const LIKE_ICON = 'likeIcon';
const DISLIKE_ICON = 'dislikeIcon';
const MAKE_AN_OFFER_ICON = 'makeAnOffer';
const BUY_NOW_ICON = 'buyNowIcon';
const DETAIL_ICON = 'detailIcon';
const SALE_ICON = 'saleIcon';
const NO_IMAGE = 'NoImage';
const ICON_TICK = 'IconTick';
const ICON_CLOSE = 'IconClose';
const ICON_STATUS = 'IconStatus';
const ICON_VIEW = 'IconView';
const ICON_EDIT = 'IconEdit';
const ICON_DELETE2 = 'IconDelete2';
const ICON_FILTER = 'IconFilter';
const DELETE_ICON = 'deleteIcon';
const UNCHECK_ICON = 'uncheckIcon';
const CHECK_ICON = 'checkIcon';
const ICON_LOCATION = 'locationIcon';
const ICON_BAG_ADDED = 'IconBagAdded';
const ICON_DELETE_CONFIRM = 'IconDeleteConfirm';
export const BACK_ICON = 'backIcon';
export const NEXT_ICON = 'nextIcon';
const ICON_DOWNLOAD = 'downloadIcon';
const TRACKING_LOGO = 'trackingLogo';
const CHECKED_ICON = 'IconChecked';
const UNCHECKED_ICON = 'IconUnchecked';
const YES_ICON = 'yesIcon';
const NO_ICON = 'noIcon';
const FILTER_ICON = 'filterIcon';
const DELETED_ICON = 'deletedIcon';
const MEASUREMENT_ICON = 'measurementIcon';
const INFO_ICON = 'infoIcon';
const INFO_ICON_WHITE = 'infoIconWhite';
const ICON_VIDEO_UPLOAD = 'videoIcon';
const ICON_TAG_UPLOAD = 'tagIcon';
const ICON_RECIEPT_UPLOAD = 'recieptIcon';
const INFO_ICON_SQUARE = 'infoIconSquare';
const ICON_CONTACT_USER = 'contactUserIcon';
const MESSAGE_ICON = 'MESSAGE_ICON';
const ICON_WHITE_BAG = 'ICON_WHITE_BAG';
const BACK_TO_EDIT = 'BACK_TO_EDIT';

const IconCollection = props => {
  const { className, rootClassName, icon } = props;

  switch (icon) {
    case BACK_TO_EDIT:
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.99997 10L3.64597 10.354L3.29297 10L3.64597 9.646L3.99997 10ZM20.5 18C20.5 18.1326 20.4473 18.2598 20.3535 18.3536C20.2598 18.4473 20.1326 18.5 20 18.5C19.8674 18.5 19.7402 18.4473 19.6464 18.3536C19.5526 18.2598 19.5 18.1326 19.5 18H20.5ZM8.64597 15.354L3.64597 10.354L4.35397 9.646L9.35397 14.646L8.64597 15.354ZM3.64597 9.646L8.64597 4.646L9.35397 5.354L4.35397 10.354L3.64597 9.646ZM3.99997 9.5H14V10.5H3.99997V9.5ZM20.5 16V18H19.5V16H20.5ZM14 9.5C15.7239 9.5 17.3772 10.1848 18.5962 11.4038C19.8151 12.6228 20.5 14.2761 20.5 16H19.5C19.5 14.5413 18.9205 13.1424 17.8891 12.1109C16.8576 11.0795 15.4587 10.5 14 10.5V9.5Z" fill="white" />
        </svg>


      );
    case ICON_WHITE_BAG:
      return (
        <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_8_142)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.26758 3.0625C9.26758 2.48234 9.03711 1.92594 8.62687 1.5157C8.21664 1.10547 7.66024 0.875 7.08008 0.875C6.49992 0.875 5.94352 1.10547 5.53328 1.5157C5.12305 1.92594 4.89258 2.48234 4.89258 3.0625V3.5H9.26758V3.0625ZM10.1426 3.0625V3.5H13.2051V12.25C13.2051 12.7141 13.0207 13.1592 12.6925 13.4874C12.3643 13.8156 11.9192 14 11.4551 14H2.70508C2.24095 14 1.79583 13.8156 1.46764 13.4874C1.13945 13.1592 0.955078 12.7141 0.955078 12.25V3.5H4.01758V3.0625C4.01758 2.25027 4.34023 1.47132 4.91456 0.896985C5.48889 0.322655 6.26785 0 7.08008 0C7.8923 0 8.67126 0.322655 9.24559 0.896985C9.81992 1.47132 10.1426 2.25027 10.1426 3.0625ZM9.57733 7.74725C9.65948 7.6651 9.70563 7.55368 9.70563 7.4375C9.70563 7.32132 9.65948 7.2099 9.57733 7.12775C9.49518 7.0456 9.38376 6.99945 9.26758 6.99945C9.1514 6.99945 9.03998 7.0456 8.95783 7.12775L6.64258 9.44388L5.63983 8.44025C5.59915 8.39957 5.55086 8.36731 5.49771 8.34529C5.44457 8.32328 5.3876 8.31195 5.33008 8.31195C5.27255 8.31195 5.21559 8.32328 5.16244 8.34529C5.1093 8.36731 5.06101 8.39957 5.02033 8.44025C4.97965 8.48093 4.94738 8.52922 4.92537 8.58236C4.90336 8.63551 4.89203 8.69247 4.89203 8.75C4.89203 8.80753 4.90336 8.86449 4.92537 8.91764C4.94738 8.97078 4.97965 9.01907 5.02033 9.05975L6.33283 10.3722C6.37347 10.413 6.42175 10.4453 6.4749 10.4674C6.52805 10.4894 6.58503 10.5008 6.64258 10.5008C6.70012 10.5008 6.75711 10.4894 6.81026 10.4674C6.86341 10.4453 6.91169 10.413 6.95233 10.3722L9.57733 7.74725Z" fill="white" />
          </g>
          <defs>
            <clipPath id="clip0_8_142">
              <rect width="14" height="14" fill="white" transform="translate(0.0800781)" />
            </clipPath>
          </defs>
        </svg>

      );
    case MESSAGE_ICON:
      return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.0002 2C12.7074 2 13.3857 2.28095 13.8858 2.78105C14.3859 3.28115 14.6668 3.95942 14.6668 4.66667V10C14.6668 10.7072 14.3859 11.3855 13.8858 11.8856C13.3857 12.3857 12.7074 12.6667 12.0002 12.6667H8.85083L5.67616 14.5713C5.58056 14.6287 5.47208 14.6612 5.36068 14.6658C5.24927 14.6704 5.13849 14.647 5.03847 14.5977C4.93845 14.5484 4.85239 14.4749 4.78816 14.3837C4.72393 14.2926 4.68359 14.1868 4.67083 14.076L4.66683 14V12.6667H4.00016C3.316 12.6667 2.65801 12.4037 2.16229 11.9322C1.66657 11.4607 1.37104 10.8166 1.33683 10.1333L1.3335 10V4.66667C1.3335 3.95942 1.61445 3.28115 2.11454 2.78105C2.61464 2.28095 3.29292 2 4.00016 2H12.0002ZM9.3335 8H5.3335C5.15668 8 4.98712 8.07024 4.86209 8.19526C4.73707 8.32029 4.66683 8.48986 4.66683 8.66667C4.66683 8.84348 4.73707 9.01305 4.86209 9.13807C4.98712 9.26309 5.15668 9.33333 5.3335 9.33333H9.3335C9.51031 9.33333 9.67988 9.26309 9.8049 9.13807C9.92992 9.01305 10.0002 8.84348 10.0002 8.66667C10.0002 8.48986 9.92992 8.32029 9.8049 8.19526C9.67988 8.07024 9.51031 8 9.3335 8ZM10.6668 5.33333H5.3335C5.15668 5.33333 4.98712 5.40357 4.86209 5.5286C4.73707 5.65362 4.66683 5.82319 4.66683 6C4.66683 6.17681 4.73707 6.34638 4.86209 6.4714C4.98712 6.59643 5.15668 6.66667 5.3335 6.66667H10.6668C10.8436 6.66667 11.0132 6.59643 11.1382 6.4714C11.2633 6.34638 11.3335 6.17681 11.3335 6C11.3335 5.82319 11.2633 5.65362 11.1382 5.5286C11.0132 5.40357 10.8436 5.33333 10.6668 5.33333Z" fill="#374151" />
        </svg>

      );
    case DELETED_ICON:
      return (
        <svg
          className={className}
          stroke="currentColor"
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 24 24"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path fill="none" d="M0 0h24v24H0z"></path>
            <path d="M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3zm-8 5v6h2v-6H9zm4 0v6h2v-6h-2zM9 4v2h6V4H9z"></path>
          </g>
        </svg>
      );
    case FILTER_ICON:
      return (
        <svg
          stroke="currentColor"
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 512 512"
          className="text-2xl"
          height="24px"
          width="24px"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M472 168H40a24 24 0 010-48h432a24 24 0 010 48zm-80 112H120a24 24 0 010-48h272a24 24 0 010 48zm-96 112h-80a24 24 0 010-48h80a24 24 0 010 48z"></path>
        </svg>
      );
    case YES_ICON:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <circle cx="8" cy="8" r="8" fill="black" />
        </svg>
      );
    case NO_ICON:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <circle cx="8" cy="8" r="7.5" fill="#EFE4D3" stroke="black" />
        </svg>
      );
    case CHECK_ICON:
      return (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="0.5" y="0.5" width="21" height="21" rx="3.5" fill="#B06B5D" />
          <rect x="0.5" y="0.5" width="21" height="21" rx="3.5" stroke="#EFE4D3" fill="#B06B5D" />
          <path
            d="M16.3333 7.6665L9.66659 14.3332L6.33325 10.9998"
            stroke="#EFE4D3"
            fill="#B06B5D"
            strokeWidth="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case UNCHECK_ICON:
      return (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="0.5" y="0.5" width="21" height="21" rx="3.5" fill="#ffff" />
          <rect x="0.5" y="0.5" width="21" height="21" rx="3.5" stroke="black" fill="#ffff" />
        </svg>
      );
    case DELETE_ICON:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M19 4H15.5L14.5 3H9.5L8.5 4H5V6H19M6 19C6 19.5304 6.21071 20.0391 6.58579 20.4142C6.96086 20.7893 7.46957 21 8 21H16C16.5304 21 17.0391 20.7893 17.4142 20.4142C17.7893 20.0391 18 19.5304 18 19V7H6V19Z"
            fill="#B06B5D"
          />
        </svg>
      );
    case DETAIL_ICON:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
        >
          <g clipPath="url(#clip0_9_3077)">
            <path
              d="M12.6599 0H4.65991C4.12948 0 3.62077 0.210714 3.2457 0.585786C2.87063 0.960859 2.65991 1.46957 2.65991 2V14C2.65991 14.5304 2.87063 15.0391 3.2457 15.4142C3.62077 15.7893 4.12948 16 4.65991 16H12.6599C13.1903 16 13.6991 15.7893 14.0741 15.4142C14.4492 15.0391 14.6599 14.5304 14.6599 14V2C14.6599 1.46957 14.4492 0.960859 14.0741 0.585786C13.6991 0.210714 13.1903 0 12.6599 0ZM5.65991 4H11.6599C11.7925 4 11.9197 4.05268 12.0135 4.14645C12.1072 4.24021 12.1599 4.36739 12.1599 4.5C12.1599 4.63261 12.1072 4.75979 12.0135 4.85355C11.9197 4.94732 11.7925 5 11.6599 5H5.65991C5.5273 5 5.40013 4.94732 5.30636 4.85355C5.21259 4.75979 5.15991 4.63261 5.15991 4.5C5.15991 4.36739 5.21259 4.24021 5.30636 4.14645C5.40013 4.05268 5.5273 4 5.65991 4ZM5.15991 6.5C5.15991 6.36739 5.21259 6.24021 5.30636 6.14645C5.40013 6.05268 5.5273 6 5.65991 6H11.6599C11.7925 6 11.9197 6.05268 12.0135 6.14645C12.1072 6.24021 12.1599 6.36739 12.1599 6.5C12.1599 6.63261 12.1072 6.75979 12.0135 6.85355C11.9197 6.94732 11.7925 7 11.6599 7H5.65991C5.5273 7 5.40013 6.94732 5.30636 6.85355C5.21259 6.75979 5.15991 6.63261 5.15991 6.5ZM5.65991 8H11.6599C11.7925 8 11.9197 8.05268 12.0135 8.14645C12.1072 8.24021 12.1599 8.36739 12.1599 8.5C12.1599 8.63261 12.1072 8.75979 12.0135 8.85355C11.9197 8.94732 11.7925 9 11.6599 9H5.65991C5.5273 9 5.40013 8.94732 5.30636 8.85355C5.21259 8.75979 5.15991 8.63261 5.15991 8.5C5.15991 8.36739 5.21259 8.24021 5.30636 8.14645C5.40013 8.05268 5.5273 8 5.65991 8ZM5.65991 10H8.65991C8.79252 10 8.9197 10.0527 9.01347 10.1464C9.10723 10.2402 9.15991 10.3674 9.15991 10.5C9.15991 10.6326 9.10723 10.7598 9.01347 10.8536C8.9197 10.9473 8.79252 11 8.65991 11H5.65991C5.5273 11 5.40013 10.9473 5.30636 10.8536C5.21259 10.7598 5.15991 10.6326 5.15991 10.5C5.15991 10.3674 5.21259 10.2402 5.30636 10.1464C5.40013 10.0527 5.5273 10 5.65991 10Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0_9_3077">
              <rect width="16" height="16" fill="white" transform="translate(0.659912)" />
            </clipPath>
          </defs>
        </svg>
      );
    case SALE_ICON:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
        >
          <g clipPath="url(#clip0_9_3080)">
            <path
              d="M5.90991 14.25C6.73834 14.25 7.40991 13.5784 7.40991 12.75C7.40991 11.9216 6.73834 11.25 5.90991 11.25C5.08148 11.25 4.40991 11.9216 4.40991 12.75C4.40991 13.5784 5.08148 14.25 5.90991 14.25Z"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.4099 14.25C14.2383 14.25 14.9099 13.5784 14.9099 12.75C14.9099 11.9216 14.2383 11.25 13.4099 11.25C12.5815 11.25 11.9099 11.9216 11.9099 12.75C11.9099 13.5784 12.5815 14.25 13.4099 14.25Z"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.40991 12.75H2.90991V9.75M2.15991 3.75H10.4099V12.75M7.40991 12.75H11.9099M14.9099 12.75H16.4099V8.25M16.4099 8.25H10.4099M16.4099 8.25L14.1599 4.5H10.4099"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.90991 6.75H5.90991"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_9_3080">
              <rect width="18" height="18" fill="white" transform="translate(0.659912)" />
            </clipPath>
          </defs>
        </svg>
      );
    case MAKE_AN_OFFER_ICON:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="14"
          viewBox="0 0 15 14"
          fill="none"
        >
          <g clipPath="url(#clip0_9_3044)">
            <path
              d="M13.099 6.75508L7.84899 1.50508C7.63899 1.29508 7.34732 1.16675 7.02649 1.16675H2.94316C2.30149 1.16675 1.77649 1.69175 1.77649 2.33341V6.41675C1.77649 6.73758 1.90482 7.02925 2.12066 7.24508L7.37066 12.4951C7.58066 12.7051 7.87232 12.8334 8.19316 12.8334C8.51399 12.8334 8.80566 12.7051 9.01566 12.4892L13.099 8.40591C13.3148 8.19591 13.4432 7.90425 13.4432 7.58341C13.4432 7.26258 13.309 6.96508 13.099 6.75508ZM3.81816 4.08341C3.33399 4.08341 2.94316 3.69258 2.94316 3.20841C2.94316 2.72425 3.33399 2.33341 3.81816 2.33341C4.30232 2.33341 4.69316 2.72425 4.69316 3.20841C4.69316 3.69258 4.30232 4.08341 3.81816 4.08341Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0_9_3044">
              <rect width="14" height="14" fill="white" transform="translate(0.609863)" />
            </clipPath>
          </defs>
        </svg>
      );
    case BUY_NOW_ICON:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="14"
          viewBox="0 0 15 14"
          fill="none"
        >
          <g clipPath="url(#clip0_9_3053)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.26746 3.0625C9.26746 2.48234 9.03699 1.92594 8.62675 1.5157C8.21652 1.10547 7.66012 0.875 7.07996 0.875C6.49979 0.875 5.9434 1.10547 5.53316 1.5157C5.12292 1.92594 4.89246 2.48234 4.89246 3.0625V3.5H9.26746V3.0625ZM10.1425 3.0625V3.5H13.205V12.25C13.205 12.7141 13.0206 13.1592 12.6924 13.4874C12.3642 13.8156 11.9191 14 11.455 14H2.70496C2.24083 14 1.79571 13.8156 1.46752 13.4874C1.13933 13.1592 0.954956 12.7141 0.954956 12.25V3.5H4.01746V3.0625C4.01746 2.25027 4.34011 1.47132 4.91444 0.896985C5.48877 0.322655 6.26773 0 7.07996 0C7.89218 0 8.67114 0.322655 9.24547 0.896985C9.8198 1.47132 10.1425 2.25027 10.1425 3.0625ZM9.57721 7.74725C9.65936 7.6651 9.70551 7.55368 9.70551 7.4375C9.70551 7.32132 9.65936 7.2099 9.57721 7.12775C9.49506 7.0456 9.38363 6.99945 9.26746 6.99945C9.15128 6.99945 9.03986 7.0456 8.95771 7.12775L6.64246 9.44388L5.63971 8.44025C5.59903 8.39957 5.55074 8.36731 5.49759 8.34529C5.44444 8.32328 5.38748 8.31195 5.32996 8.31195C5.27243 8.31195 5.21547 8.32328 5.16232 8.34529C5.10917 8.36731 5.06088 8.39957 5.02021 8.44025C4.97953 8.48093 4.94726 8.52922 4.92525 8.58236C4.90323 8.63551 4.8919 8.69247 4.8919 8.75C4.8919 8.80753 4.90323 8.86449 4.92525 8.91764C4.94726 8.97078 4.97953 9.01907 5.02021 9.05975L6.33271 10.3722C6.37335 10.413 6.42162 10.4453 6.47478 10.4674C6.52793 10.4894 6.58491 10.5008 6.64246 10.5008C6.7 10.5008 6.75698 10.4894 6.81014 10.4674C6.86329 10.4453 6.91157 10.413 6.95221 10.3722L9.57721 7.74725Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_9_3053">
              <rect width="14" height="14" fill="white" transform="translate(0.0799561)" />
            </clipPath>
          </defs>
        </svg>
      );
    case LOGO:
      return (
        <svg
          width="84"
          height="29"
          viewBox="0 0 84 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.04425 8.73592C1.74958 8.23867 1.23392 7.90717 0.49725 7.74142C2.11792 7.59409 3.61888 7.52042 5.00013 7.52042C5.00013 8.99375 5.00933 10.0895 5.02775 10.8078C5.28558 9.94221 5.78283 9.19634 6.5195 8.57017C7.27458 7.944 8.10333 7.63092 9.00575 7.63092C9.44775 7.63092 9.86213 7.7138 10.2489 7.87955C10.654 8.0453 10.8566 8.31234 10.8566 8.68067C10.8566 8.95692 10.7738 9.18713 10.608 9.3713C10.4607 9.53705 10.2765 9.61992 10.0555 9.61992C9.70558 9.61992 9.31883 9.46338 8.89525 9.1503C8.49008 8.83721 8.09413 8.68067 7.70738 8.68067H7.514C7.05358 8.7175 6.64842 8.95692 6.2985 9.39892C5.967 9.84092 5.70917 10.3842 5.525 11.0288C5.35925 11.6734 5.23033 12.2535 5.13825 12.7692C5.06458 13.2848 5.01854 13.7637 5.00013 14.2057C4.94488 17.5759 5.06458 19.5097 5.35925 20.0069C5.58025 20.3568 5.91175 20.5778 6.35375 20.6699H1.04975C1.547 20.5778 1.88771 20.3476 2.07188 19.9793C2.18238 19.8135 2.26525 19.5281 2.3205 19.1229C2.39417 18.6993 2.44021 18.1745 2.45863 17.5483C2.47704 16.9221 2.48625 16.388 2.48625 15.946C2.50467 15.504 2.50467 14.9515 2.48625 14.2885C2.48625 13.6255 2.48625 13.2756 2.48625 13.2388C2.48625 10.6789 2.33892 9.17792 2.04425 8.73592ZM21.7562 14.2609C21.7562 13.5795 21.7102 12.9349 21.6181 12.3272C21.5444 11.701 21.3879 11.0104 21.1484 10.2553C20.909 9.4818 20.5131 8.87405 19.9606 8.43205C19.4081 7.97163 18.7267 7.74142 17.9163 7.74142C15.4301 7.74142 14.1869 9.90538 14.1869 14.2333C14.1869 14.9147 14.2238 15.5685 14.2974 16.1947C14.3895 16.8024 14.5461 17.4838 14.7671 18.2389C15.0065 18.994 15.4024 19.6018 15.9549 20.0622C16.5074 20.5042 17.1981 20.7252 18.0268 20.7252C20.5131 20.7252 21.7562 18.5704 21.7562 14.2609ZM17.8887 7.52042C19.8224 7.52042 21.3971 8.14659 22.6126 9.39892C23.8281 10.6328 24.4358 12.2535 24.4358 14.2609C24.4358 16.2499 23.8465 17.8614 22.6678 19.0953C21.5076 20.3292 19.9606 20.9462 18.0268 20.9462C16.0747 20.9462 14.5 20.3292 13.3029 19.0953C12.1059 17.843 11.5073 16.2223 11.5073 14.2333C11.5073 12.2811 12.0967 10.6789 13.2753 9.42655C14.454 8.1558 15.9918 7.52042 17.8887 7.52042ZM29.4893 7.8243C28.8631 8.00846 28.55 8.46888 28.55 9.20555C28.55 9.85013 28.8263 10.9367 29.3788 12.4653C29.9497 13.9939 30.585 15.5593 31.2849 17.1615C31.9847 18.7638 32.353 19.611 32.3899 19.703C32.5372 19.2242 33.0345 17.935 33.8816 15.8355C34.7288 13.7176 35.3089 12.189 35.622 11.2498C35.6036 11.213 35.5483 11.0656 35.4563 10.8078C35.3642 10.5315 35.2997 10.3658 35.2629 10.3105C35.2445 10.2369 35.1892 10.0895 35.0971 9.86855C35.005 9.62913 34.9314 9.47259 34.8761 9.39892C34.8209 9.30684 34.738 9.16871 34.6275 8.98455C34.5354 8.80038 34.4433 8.67146 34.3513 8.5978C34.2592 8.50571 34.1395 8.40442 33.9921 8.29392C33.8632 8.165 33.7251 8.07292 33.5778 8.01767C33.4304 7.944 33.2739 7.87955 33.1081 7.8243H38.6331C38.007 8.00846 37.6939 8.46888 37.6939 9.20555C37.6939 9.7028 37.878 10.5131 38.2464 11.6365C38.6331 12.7415 39.0383 13.8097 39.4619 14.841C39.8855 15.854 40.3275 16.8853 40.7879 17.935C41.2483 18.9848 41.5061 19.5741 41.5614 19.703C41.6903 19.2979 42.3257 17.6404 43.4675 14.7305C44.6093 11.8023 45.2263 9.99746 45.3184 9.31605C45.3368 9.09505 45.3092 8.91088 45.2355 8.76355C45.1803 8.5978 45.0605 8.46888 44.8764 8.3768C44.6922 8.2663 44.5265 8.18342 44.3791 8.12817C44.2502 8.07292 44.0476 8.01767 43.7714 7.96242C43.5135 7.88875 43.3478 7.84271 43.2741 7.8243L47.5836 7.85192C47.1785 7.99925 46.7825 8.34917 46.3958 8.90167C46.0274 9.45417 45.7328 9.98825 45.5118 10.5039C45.3092 11.0012 44.95 11.9036 44.4344 13.2112L41.5614 20.7528H39.4895L35.843 11.7747L35.2905 13.2112L32.3899 20.7528H30.3733L26.6439 11.5537C26.607 11.4432 26.515 11.2038 26.3676 10.8354C26.2387 10.4671 26.1374 10.2093 26.0638 10.0619C26.0085 9.89617 25.898 9.66596 25.7323 9.3713C25.5849 9.05821 25.4376 8.828 25.2903 8.68067C25.1429 8.51492 24.9588 8.34917 24.7378 8.18342C24.4983 8.01767 24.2497 7.89796 23.9919 7.8243H29.4893ZM53.9751 7.79667C51.7651 7.79667 50.4484 9.80409 50.0248 13.8189H57.5388C57.5019 13.1191 57.4467 12.5021 57.373 11.968C57.2994 11.434 57.152 10.8078 56.931 10.0895C56.71 9.3713 56.3417 8.80959 55.826 8.40442C55.3288 7.99925 54.7118 7.79667 53.9751 7.79667ZM49.9971 14.0952C49.9971 14.8134 50.0248 15.458 50.08 16.0289C50.1353 16.5814 50.255 17.1615 50.4391 17.7693C50.6417 18.3586 50.8996 18.8467 51.2126 19.2334C51.5441 19.6202 51.9954 19.9425 52.5663 20.2003C53.1556 20.4581 53.8462 20.587 54.6381 20.587C55.5774 20.587 56.5259 20.3016 57.4835 19.7307C58.4596 19.1598 59.2239 18.4231 59.7764 17.5207H59.9698C59.5278 18.5704 58.7451 19.4084 57.6216 20.0345C56.5166 20.6423 55.3748 20.9462 54.1961 20.9462C52.1335 20.9462 50.4391 20.3568 49.1131 19.1782C47.8056 17.9811 47.1518 16.388 47.1518 14.399C47.1518 12.3364 47.7503 10.6789 48.9474 9.42655C50.1445 8.1558 51.7744 7.52042 53.837 7.52042C55.7524 7.52042 57.2902 8.12817 58.4504 9.34367C59.6107 10.5592 60.2092 12.143 60.246 14.0952H49.9971ZM60.95 0.614172C62.276 0.485254 63.6849 0.420796 65.1767 0.420796V16.0013C65.1767 18.1376 65.2964 19.4544 65.5358 19.9517C65.7384 20.3016 66.0791 20.541 66.5579 20.6699H61.2539C61.7327 20.5226 62.0642 20.2924 62.2484 19.9793C62.5247 19.4636 62.6628 18.1376 62.6628 16.0013V5.25517C62.6628 3.00834 62.5339 1.70996 62.276 1.36005C62.2024 1.17588 62.0458 1.02855 61.8064 0.918046L61.7788 0.890421C61.5025 0.724671 61.2171 0.632588 60.9224 0.614172H60.95ZM70.2692 11.5537C70.1771 11.3695 70.0205 11.0104 69.7995 10.4763C69.5785 9.94221 69.3944 9.54625 69.247 9.28842C69.1181 9.03059 68.8971 8.75434 68.584 8.45967C68.2709 8.14659 67.9118 7.9348 67.5067 7.8243H73.1698C72.5436 8.00846 72.2305 8.46888 72.2305 9.20555C72.2305 9.85013 72.516 10.8446 73.0869 12.189C73.6578 13.5335 74.3208 14.9239 75.0759 16.3604C75.831 17.7785 76.2269 18.5244 76.2638 18.598C76.4295 18.0824 77.1017 16.5722 78.2804 14.0675C79.4591 11.5629 80.0852 9.97905 80.1589 9.31605C80.1773 9.09505 80.1497 8.91088 80.076 8.76355C80.0024 8.5978 79.8734 8.46888 79.6893 8.3768C79.5051 8.2663 79.3302 8.18342 79.1644 8.12817C79.0171 8.07292 78.8145 8.01767 78.5567 7.96242C78.2988 7.90717 78.1239 7.86113 78.0318 7.8243L82.507 7.85192C82.2492 7.944 82.019 8.09134 81.8164 8.29392C81.6138 8.47809 81.402 8.76355 81.181 9.1503C80.96 9.53705 80.7759 9.88696 80.6285 10.2C80.4812 10.4947 80.2602 10.9735 79.9655 11.6365C79.6893 12.2995 79.4591 12.8244 79.2749 13.2112L75.214 22.0788C74.1643 24.4177 73.0777 26.3699 71.9543 27.9353C71.678 28.322 71.3465 28.5154 70.9598 28.5154C70.6099 28.5154 70.306 28.3589 70.0482 28.0458C69.9008 27.8985 69.7903 27.6959 69.7167 27.438C69.643 27.1986 69.6154 26.9776 69.6338 26.775C69.6706 26.5725 69.7443 26.4712 69.8548 26.4712C69.8732 26.4712 69.8824 26.4712 69.8824 26.4712L69.9377 26.4988C70.1771 26.5909 70.3889 26.6369 70.573 26.6369C71.9174 26.6369 73.3724 24.915 74.9378 21.471L70.2692 11.5537ZM80.8623 18.7914C81.1201 18.552 81.4424 18.4323 81.8291 18.4323C82.2159 18.4323 82.5382 18.552 82.796 18.7914C83.0538 19.0308 83.1828 19.3255 83.1828 19.6754C83.1828 20.0438 83.0538 20.3476 82.796 20.587C82.5382 20.8265 82.2159 20.9462 81.8291 20.9462C81.424 20.9462 81.0925 20.8265 80.8346 20.587C80.5952 20.3476 80.4755 20.0438 80.4755 19.6754C80.4755 19.3255 80.6044 19.0308 80.8623 18.7914Z"
            fill="#F3F4F6"
          />
        </svg>
      );
    case DOWN_ARROW_ICON:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M6.175 7.15832L10 10.975L13.825 7.15833L15 8.33333L10 13.3333L5 8.33332L6.175 7.15832Z"
            fill="black"
          />
        </svg>
      );
    case ADD_TO_BAG_ICON:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="17"
          viewBox="0 0 15 17"
          fill="none"
        >
          <path
            d="M7.65995 1.64001C7.12952 1.64001 6.62081 1.85073 6.24574 2.2258C5.87067 2.60087 5.65995 3.10958 5.65995 3.64001V5.64001H4.65995V3.64001C4.65995 2.84437 4.97602 2.0813 5.53863 1.51869C6.10124 0.956085 6.8643 0.640015 7.65995 0.640015C8.4556 0.640015 9.21867 0.956085 9.78127 1.51869C10.3439 2.0813 10.66 2.84437 10.66 3.64001V5.64001H9.65995V3.64001C9.65995 3.10958 9.44924 2.60087 9.07417 2.2258C8.69909 1.85073 8.19039 1.64001 7.65995 1.64001ZM4.65995 5.64001H3.01995C2.66083 5.64009 2.31365 5.76902 2.04151 6.00335C1.76938 6.23769 1.59034 6.56188 1.53695 6.91701L0.509954 13.77C0.456741 14.1256 0.480853 14.4885 0.580644 14.8339C0.680435 15.1793 0.853557 15.4991 1.0882 15.7716C1.32284 16.044 1.61348 16.2626 1.9403 16.4125C2.26711 16.5623 2.62241 16.6399 2.98195 16.64H12.337C12.6966 16.6401 13.052 16.5626 13.3789 16.4128C13.7059 16.263 13.9966 16.0444 14.2314 15.7719C14.4661 15.4995 14.6393 15.1796 14.7392 14.8341C14.839 14.4886 14.8632 14.1257 14.81 13.77L13.782 6.91701C13.7286 6.56205 13.5497 6.23799 13.2778 6.00368C13.0058 5.76936 12.6589 5.64033 12.3 5.64001H10.66V7.14001C10.66 7.27262 10.6073 7.3998 10.5135 7.49357C10.4197 7.58734 10.2926 7.64001 10.16 7.64001C10.0273 7.64001 9.90017 7.58734 9.8064 7.49357C9.71263 7.3998 9.65995 7.27262 9.65995 7.14001V5.64001H5.65995V7.14001C5.65995 7.27262 5.60728 7.3998 5.51351 7.49357C5.41974 7.58734 5.29256 7.64001 5.15995 7.64001C5.02735 7.64001 4.90017 7.58734 4.8064 7.49357C4.71263 7.3998 4.65995 7.27262 4.65995 7.14001V5.64001Z"
            fill="black"
          />
        </svg>
      );
    case LIKE_ICON:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
        >
          <g clipPath="url(#clip0_8_168)">
            <path
              fill="none"
              d="M15.7898 3.9575C15.4067 3.57425 14.9519 3.27023 14.4513 3.06281C13.9507 2.85539 13.4141 2.74863 12.8723 2.74863C12.3304 2.74863 11.7938 2.85539 11.2932 3.06281C10.7926 3.27023 10.3378 3.57425 9.95476 3.9575L9.15976 4.7525L8.36476 3.9575C7.59099 3.18373 6.54153 2.74903 5.44726 2.74903C4.35298 2.74903 3.30353 3.18373 2.52976 3.9575C1.75599 4.73127 1.32129 5.78072 1.32129 6.875C1.32129 7.96927 1.75599 9.01873 2.52976 9.7925L3.32476 10.5875L9.15976 16.4225L14.9948 10.5875L15.7898 9.7925C16.173 9.40943 16.477 8.95461 16.6844 8.45401C16.8919 7.95342 16.9986 7.41686 16.9986 6.875C16.9986 6.33313 16.8919 5.79657 16.6844 5.29598C16.477 4.79539 16.173 4.34056 15.7898 3.9575Z"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_8_168">
              <rect width="18" height="18" fill="white" transform="translate(0.160156 0.5)" />
            </clipPath>
          </defs>
        </svg>
      );

    case DISLIKE_ICON:
      return (
        <svg
          style={{ fill: '#b06b5d' }}
          stroke="currentColor"
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 16 16"
          className="text-secondary-3"
          height="1em"
          width="1em"
        >
          <path d="M4 1c2.21 0 4 1.755 4 3.92C8 2.755 9.79 1 12 1s4 1.755 4 3.92c0 3.263-3.234 4.414-7.608 9.608a.513.513 0 0 1-.784 0C3.234 9.334 0 8.183 0 4.92 0 2.755 1.79 1 4 1z"></path>
        </svg>
      );

    case ICON_SEND:
      return (
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1_121)">
            <path
              d="M11.458 13.4572L16 3.83984L0 8.92718L6.13067 10.2358L6.15933 13.4998L7.99867 11.7552L6.56733 10.3712L11.458 13.4572Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1_121">
              <rect width="16" height="16" fill="white" transform="translate(0 0.669922)" />
            </clipPath>
          </defs>
        </svg>
      );

    case ICON_LIKE:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
        >
          <g clipPath="url(#clip0_8_168)">
            <path
              fill="none"
              d="M15.7898 3.9575C15.4067 3.57425 14.9519 3.27023 14.4513 3.06281C13.9507 2.85539 13.4141 2.74863 12.8723 2.74863C12.3304 2.74863 11.7938 2.85539 11.2932 3.06281C10.7926 3.27023 10.3378 3.57425 9.95476 3.9575L9.15976 4.7525L8.36476 3.9575C7.59099 3.18373 6.54153 2.74903 5.44726 2.74903C4.35298 2.74903 3.30353 3.18373 2.52976 3.9575C1.75599 4.73127 1.32129 5.78072 1.32129 6.875C1.32129 7.96927 1.75599 9.01873 2.52976 9.7925L3.32476 10.5875L9.15976 16.4225L14.9948 10.5875L15.7898 9.7925C16.173 9.40943 16.477 8.95461 16.6844 8.45401C16.8919 7.95342 16.9986 7.41686 16.9986 6.875C16.9986 6.33313 16.8919 5.79657 16.6844 5.29598C16.477 4.79539 16.173 4.34056 15.7898 3.9575Z"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_8_168">
              <rect width="18" height="18" fill="white" transform="translate(0.160156 0.5)" />
            </clipPath>
          </defs>
        </svg>
      );

    case ICON_BAG:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
        >
          <g clipPath="url(#clip0_8_172)">
            <path
              d="M9.15968 1.625C9.75642 1.625 10.3287 1.86205 10.7507 2.28401C11.1726 2.70597 11.4097 3.27826 11.4097 3.875V6.125H6.90968V3.875C6.90968 3.27826 7.14674 2.70597 7.56869 2.28401C7.99065 1.86205 8.56295 1.625 9.15968 1.625ZM12.5347 6.125V3.875C12.5347 2.97989 12.1791 2.12145 11.5462 1.48851C10.9132 0.855579 10.0548 0.5 9.15968 0.5C8.26458 0.5 7.40613 0.855579 6.7732 1.48851C6.14026 2.12145 5.78468 2.97989 5.78468 3.875V6.125H3.93968C3.53567 6.12509 3.14509 6.27013 2.83894 6.53375C2.53278 6.79738 2.33137 7.1621 2.27131 7.56163L1.11593 15.2712C1.05607 15.6713 1.0832 16.0795 1.19546 16.4681C1.30773 16.8567 1.50249 17.2165 1.76646 17.523C2.03043 17.8295 2.35741 18.0754 2.72507 18.244C3.09274 18.4126 3.49245 18.4999 3.89693 18.5H14.4213C14.8259 18.5001 15.2257 18.4129 15.5935 18.2443C15.9613 18.0758 16.2884 17.8299 16.5525 17.5234C16.8166 17.2169 17.0115 16.8571 17.1238 16.4684C17.2362 16.0797 17.2633 15.6714 17.2034 15.2712L16.0469 7.56163C15.9869 7.16229 15.7857 6.79772 15.4797 6.53412C15.1738 6.27052 14.7835 6.12536 14.3797 6.125H12.5347ZM11.4097 7.25V8.9375C11.4097 9.08668 11.4689 9.22976 11.5744 9.33525C11.6799 9.44074 11.823 9.5 11.9722 9.5C12.1214 9.5 12.2644 9.44074 12.3699 9.33525C12.4754 9.22976 12.5347 9.08668 12.5347 8.9375V7.25H14.3786C14.5132 7.25013 14.6434 7.29857 14.7454 7.38652C14.8473 7.47446 14.9144 7.59607 14.9343 7.72925L16.0908 15.4366C16.1269 15.6767 16.1108 15.9218 16.0435 16.155C15.9762 16.3883 15.8594 16.6043 15.7011 16.7883C15.5427 16.9723 15.3465 17.12 15.1258 17.2213C14.9051 17.3225 14.6652 17.3749 14.4224 17.375H3.89693C3.65415 17.3749 3.41424 17.3225 3.19358 17.2213C2.97291 17.12 2.7767 16.9723 2.61832 16.7883C2.45994 16.6043 2.34313 16.3883 2.27587 16.155C2.2086 15.9218 2.19247 15.6767 2.22856 15.4366L3.38506 7.72925C3.40496 7.59626 3.47184 7.4748 3.57359 7.38688C3.67534 7.29896 3.80521 7.2504 3.93968 7.25H5.78468V8.9375C5.78468 9.08668 5.84395 9.22976 5.94944 9.33525C6.05493 9.44074 6.198 9.5 6.34718 9.5C6.49637 9.5 6.63944 9.44074 6.74493 9.33525C6.85042 9.22976 6.90968 9.08668 6.90968 8.9375V7.25H11.4097Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0_8_172">
              <rect width="18" height="18" fill="white" transform="translate(0.160156 0.5)" />
            </clipPath>
          </defs>
        </svg>
      );

    case CROSS_ICON:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="29"
          viewBox="0 0 30 29"
          fill="none"
        >
          <path
            d="M24.1003 22.0151C24.1874 22.0993 24.2565 22.1992 24.3037 22.3092C24.3508 22.4193 24.3751 22.5372 24.3751 22.6562C24.3751 22.7753 24.3508 22.8932 24.3037 23.0032C24.2565 23.1132 24.1874 23.2132 24.1003 23.2974C24.0132 23.3816 23.9098 23.4484 23.796 23.494C23.6822 23.5395 23.5602 23.563 23.437 23.563C23.3139 23.563 23.1919 23.5395 23.0781 23.494C22.9643 23.4484 22.8609 23.3816 22.7738 23.2974L14.9995 15.7812L7.22533 23.2974C7.04941 23.4675 6.81082 23.563 6.56204 23.563C6.31327 23.563 6.07468 23.4675 5.89876 23.2974C5.72285 23.1274 5.62402 22.8967 5.62402 22.6562C5.62402 22.4158 5.72285 22.1851 5.89876 22.0151L13.6742 14.5L5.89876 6.98491C5.72285 6.81486 5.62402 6.58422 5.62402 6.34374C5.62402 6.10325 5.72285 5.87261 5.89876 5.70256C6.07468 5.53251 6.31327 5.43698 6.56204 5.43698C6.81082 5.43698 7.04941 5.53251 7.22533 5.70256L14.9995 13.2188L22.7738 5.70256C22.9497 5.53251 23.1883 5.43698 23.437 5.43698C23.6858 5.43698 23.9244 5.53251 24.1003 5.70256C24.2762 5.87261 24.3751 6.10325 24.3751 6.34374C24.3751 6.58422 24.2762 6.81486 24.1003 6.98491L16.3249 14.5L24.1003 22.0151Z"
            fill="black"
          />
        </svg>
      );

    case PASSWORD_SHOW_ICON:
      return (
        <svg
          width="22"
          height="16"
          viewBox="0 0 22 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="22" height="16" fill="#F5F5F5" />
          <g id="Signup Screen">
            <rect width="1920" height="1080" transform="translate(-1164 -609)" fill="#EFE4D3" />
            <rect
              id="Rectangle 7"
              x="-1164"
              y="-616"
              width="1920"
              height="1059"
              fill="#292C2F"
              fillOpacity="0.36"
            />
            <g id="div.mx-auto" filter="url(#filter0_dd_0_1)">
              <rect x="-537" y="-444" width="634" height="751" rx="4" fill="white" />
              <g id="Group 12"></g>
              <path
                id="Vector"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.068601 7.636C1.8026 3.194 5.8836 0 10.9996 0C16.1156 0 20.1966 3.194 21.9316 7.636C22.0231 7.87005 22.0231 8.12995 21.9316 8.364C20.1966 12.806 16.1156 16 10.9996 16C5.8836 16 1.8026 12.806 0.068601 8.364C-0.022867 8.12995 -0.022867 7.87005 0.068601 7.636ZM10.9996 11C11.7953 11 12.5583 10.6839 13.1209 10.1213C13.6835 9.55871 13.9996 8.79565 13.9996 8C13.9996 7.20435 13.6835 6.44129 13.1209 5.87868C12.5583 5.31607 11.7953 5 10.9996 5C10.204 5 9.44089 5.31607 8.87828 5.87868C8.31567 6.44129 7.9996 7.20435 7.9996 8C7.9996 8.79565 8.31567 9.55871 8.87828 10.1213C9.44089 10.6839 10.204 11 10.9996 11Z"
                fill="black"
              />
            </g>
          </g>
          <g id="Group 3"></g>
          <defs>
            <filter
              id="filter0_dd_0_1"
              x="-557"
              y="-444"
              width="674"
              height="791"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feMorphology
                radius="6"
                operator="erode"
                in="SourceAlpha"
                result="effect1_dropShadow_0_1"
              />
              <feOffset dy="8" />
              <feGaussianBlur stdDeviation="5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feMorphology
                radius="5"
                operator="erode"
                in="SourceAlpha"
                result="effect2_dropShadow_0_1"
              />
              <feOffset dy="20" />
              <feGaussianBlur stdDeviation="12.5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_0_1" result="effect2_dropShadow_0_1" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect2_dropShadow_0_1"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      );
    case PASSWORD_HIDE_ICON:
      return (
        <svg width="22px" height="22px" viewBox="0 0 1.32 1.32" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0h1.32v1.32H0z" fill="none" />
          <g id="Shopicon">
            <path d="M0.329 0.913 0.197 1.045 0.275 1.123l0.146 -0.146C0.491 1.017 0.572 1.045 0.66 1.045c0.33 0 0.55 -0.385 0.55 -0.385s-0.081 -0.142 -0.219 -0.253L1.123 0.275 1.045 0.197l-0.146 0.146C0.829 0.303 0.748 0.275 0.66 0.275 0.33 0.275 0.11 0.66 0.11 0.66s0.081 0.142 0.219 0.253zM0.44 0.66a0.22 0.22 0 0 1 0.22 -0.22c0.041 0 0.079 0.011 0.112 0.031l-0.083 0.083A0.109 0.109 0 0 0 0.66 0.55c-0.061 0 -0.11 0.049 -0.11 0.11 0 0.01 0.002 0.019 0.004 0.028l-0.083 0.083A0.219 0.219 0 0 1 0.44 0.66zm0.44 0a0.22 0.22 0 0 1 -0.22 0.22 0.219 0.219 0 0 1 -0.112 -0.031l0.083 -0.083c0.009 0.002 0.018 0.004 0.028 0.004 0.061 0 0.11 -0.049 0.11 -0.11 0 -0.01 -0.002 -0.019 -0.004 -0.028l0.083 -0.083A0.219 0.219 0 0 1 0.88 0.66z" />
          </g>
        </svg>
      );
    case ICON_PLUS:
      return (
        <svg
          stroke="currentColor"
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 512 512"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="32"
            d="M256 112v288m144-144H112"
          ></path>
        </svg>
      );
    case ICON_MANAGE:
      return (
        <svg
          stroke="currentColor"
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 24 24"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path fill="none" d="M0 0h24v24H0z"></path>
            <path d="M8 4h13v2H8V4zm-5-.5h3v3H3v-3zm0 7h3v3H3v-3zm0 7h3v3H3v-3zM8 11h13v2H8v-2zm0 7h13v2H8v-2z"></path>
          </g>
        </svg>
      );
    case ICON_UPLOAD_INBOX:
      return (
        <svg width="40px" height="40px" viewBox="0 0 1.2 1.2" xmlns="http://www.w3.org/2000/svg"><path d="M1.2 0.6a0.25 0.25 0 0 1 -0.25 0.25h-0.1v-0.05h0.1a0.2 0.2 0 0 0 0.031 -0.397l-0.04 -0.006 -0.003 -0.04a0.265 0.265 0 0 0 -0.511 -0.079L0.409 0.33l-0.049 -0.024A0.115 0.115 0 0 0 0.31 0.294a0.11 0.11 0 0 0 -0.058 0.017 0.11 0.11 0 0 0 -0.049 0.07l-0.006 0.025 -0.024 0.01A0.2 0.2 0 0 0 0.25 0.8h0.15v0.05H0.25a0.25 0.25 0 0 1 -0.097 -0.481 0.16 0.16 0 0 1 0.071 -0.101 0.159 0.159 0 0 1 0.085 -0.025 0.165 0.165 0 0 1 0.072 0.017 0.315 0.315 0 0 1 0.607 0.093A0.25 0.25 0 0 1 1.2 0.6m-0.55 -0.015 0.132 0.132 0.035 -0.035L0.625 0.49l-0.193 0.193 0.035 0.035L0.6 0.585V1.1h0.05z" /><path fill="none" d="M0 0h1.2v1.2H0z" /></svg>
      );
    case ICON_UPLOAD:
      return (
        <svg
          width="70"
          height="70"
          viewBox="0 0 70 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.9183 37.9167H17.5C15.1794 37.9167 12.9538 36.9948 11.3128 35.3539C9.67187 33.7129 8.75 31.4873 8.75 29.1667C8.75 26.8461 9.67187 24.6205 11.3128 22.9795C12.9538 21.3386 15.1794 20.4167 17.5 20.4167C18.3167 20.4167 18.725 20.4167 19.0079 20.3584C19.8771 20.1834 20.2913 19.918 20.8046 19.1946C20.9738 18.9613 21.2129 18.4305 21.6883 17.3688C22.8388 14.8005 24.7077 12.6198 27.0697 11.0898C29.4316 9.55972 32.1858 8.74561 35 8.74561C37.8142 8.74561 40.5684 9.55972 42.9303 11.0898C45.2923 12.6198 47.1612 14.8005 48.3117 17.3688C48.7871 18.4305 49.0263 18.9584 49.1954 19.1946C49.7117 19.918 50.1229 20.1863 50.9921 20.3613C51.2779 20.4167 51.6863 20.4167 52.5 20.4167C54.8206 20.4167 57.0462 21.3386 58.6872 22.9795C60.3281 24.6205 61.25 26.8461 61.25 29.1667C61.25 31.4873 60.3281 33.7129 58.6872 35.3539C57.0462 36.9948 54.8206 37.9167 52.5 37.9167H49.0817L39.1242 27.9592L35 23.835L30.8758 27.9592L20.9183 37.9167Z"
            fill="#4B5563"
          />
          <path
            d="M35 35L32.9379 32.9379L35 30.8759L37.0621 32.9379L35 35ZM37.9167 61.25C37.9167 62.0236 37.6094 62.7654 37.0624 63.3124C36.5154 63.8594 35.7736 64.1667 35 64.1667C34.2265 64.1667 33.4846 63.8594 32.9376 63.3124C32.3906 62.7654 32.0833 62.0236 32.0833 61.25H37.9167ZM21.2713 44.6046L32.9379 32.9379L37.0621 37.0621L25.3954 48.7288L21.2713 44.6046ZM37.0621 32.9379L48.7288 44.6046L44.6046 48.7288L32.9379 37.0621L37.0621 32.9379ZM37.9167 35V61.25H32.0833V35H37.9167Z"
            fill="#4B5563"
          />
        </svg>
      );
    case ICON_DELETE:
      return (
        <svg
          stroke="currentColor"
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 24 24"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M5 20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8h2V6h-4V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3v2h2zM9 4h6v2H9zM8 8h9v12H7V8z"></path>
          <path d="M9 10h2v8H9zm4 0h2v8h-2z"></path>
        </svg>
      );
    case RIGHT_SIDE_ARROW_ICON:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7"
          height="10"
          viewBox="0 0 7 10"
          fill="none"
        >
          <path
            d="M0.158325 8.825L3.97499 5L0.158325 1.175L1.33333 0L6.33332 5L1.33333 10L0.158325 8.825Z"
            fill="black"
          />
        </svg>
      );
    case BACK_ICON:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.51176 10L13.4766 5.03906C13.8438 4.67188 13.8438 4.07813 13.4766 3.71485C13.1094 3.34766 12.5157 3.35156 12.1485 3.71485L6.52348 9.33594C6.16801 9.69141 6.1602 10.2617 6.49614 10.6289L12.1446 16.2891C12.3282 16.4727 12.5704 16.5625 12.8086 16.5625C13.0469 16.5625 13.2891 16.4727 13.4727 16.2891C13.8399 15.9219 13.8399 15.3281 13.4727 14.9648L8.51176 10Z"
            fill="black"
          />
        </svg>
      );
    case NEXT_ICON:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.4883 10L6.52344 5.03906C6.15625 4.67188 6.15625 4.07812 6.52344 3.71484C6.89062 3.35156 7.48438 3.35156 7.85156 3.71484L13.4766 9.33594C13.832 9.69141 13.8398 10.2617 13.5039 10.6289L7.85547 16.2891C7.67188 16.4727 7.42969 16.5625 7.19141 16.5625C6.95313 16.5625 6.71094 16.4727 6.52734 16.2891C6.16016 15.9219 6.16016 15.3281 6.52734 14.9648L11.4883 10Z"
            fill="black"
          />
        </svg>
      );
    case ICON_SETTINGS:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.2791 2.152C13.9091 2 13.4391 2 12.5001 2C11.5611 2 11.0921 2 10.7211 2.152C10.2285 2.35421 9.83645 2.74377 9.63107 3.235C9.53707 3.458 9.50107 3.719 9.48607 4.098C9.4794 4.3726 9.4028 4.64097 9.26352 4.87772C9.12423 5.11447 8.92686 5.31178 8.69007 5.451C8.44882 5.5851 8.17762 5.65615 7.9016 5.65754C7.62558 5.65894 7.35367 5.59065 7.11107 5.459C6.77307 5.281 6.52807 5.183 6.28607 5.151C5.75663 5.08148 5.22114 5.2238 4.79607 5.547C4.47807 5.789 4.24307 6.193 3.77407 7C3.30407 7.807 3.07007 8.21 3.01707 8.605C2.94707 9.131 3.09107 9.663 3.41707 10.084C3.56507 10.276 3.77407 10.437 4.09707 10.639C4.57407 10.936 4.88007 11.442 4.88007 12C4.88007 12.558 4.57407 13.064 4.09807 13.36C3.77407 13.563 3.56507 13.724 3.41607 13.916C3.25515 14.1239 3.13704 14.3617 3.06856 14.6156C3.00007 14.8694 2.98257 15.1343 3.01707 15.395C3.07007 15.789 3.30407 16.193 3.77407 17C4.24407 17.807 4.47807 18.21 4.79607 18.453C5.22007 18.776 5.75607 18.918 6.28607 18.849C6.52807 18.817 6.77307 18.719 7.11107 18.541C7.3538 18.4092 7.62589 18.3408 7.9021 18.3422C8.17831 18.3436 8.44969 18.4147 8.69107 18.549C9.17707 18.829 9.46507 19.344 9.48607 19.902C9.50107 20.282 9.53707 20.542 9.63107 20.765C9.83507 21.255 10.2271 21.645 10.7211 21.848C11.0911 22 11.5611 22 12.5001 22C13.4391 22 13.9091 22 14.2791 21.848C14.7716 21.6458 15.1637 21.2562 15.3691 20.765C15.4631 20.542 15.4991 20.282 15.5141 19.902C15.5341 19.344 15.8231 18.828 16.3101 18.549C16.5513 18.4149 16.8225 18.3439 17.0985 18.3425C17.3746 18.3411 17.6465 18.4093 17.8891 18.541C18.2271 18.719 18.4721 18.817 18.7141 18.849C19.2441 18.919 19.7801 18.776 20.2041 18.453C20.5221 18.211 20.7571 17.807 21.2261 17C21.6961 16.193 21.9301 15.79 21.9831 15.395C22.0174 15.1343 21.9998 14.8693 21.9311 14.6155C21.8625 14.3616 21.7442 14.1239 21.5831 13.916C21.4351 13.724 21.2261 13.563 20.9031 13.361C20.4261 13.064 20.1201 12.558 20.1201 12C20.1201 11.442 20.4261 10.936 20.9021 10.64C21.2261 10.437 21.4351 10.276 21.5841 10.084C21.745 9.87606 21.8631 9.63829 21.9316 9.38443C22.0001 9.13057 22.0176 8.86566 21.9831 8.605C21.9301 8.211 21.6961 7.807 21.2261 7C20.7561 6.193 20.5221 5.79 20.2041 5.547C19.779 5.2238 19.2435 5.08148 18.7141 5.151C18.4721 5.183 18.2271 5.281 17.8891 5.459C17.6463 5.59083 17.3743 5.65922 17.098 5.65782C16.8218 5.65642 16.5504 5.58528 16.3091 5.451C16.0725 5.31166 15.8753 5.11429 15.7362 4.87755C15.5971 4.64081 15.5206 4.37251 15.5141 4.098C15.4991 3.718 15.4631 3.458 15.3691 3.235C15.2674 2.99174 15.1188 2.77088 14.9318 2.58506C14.7448 2.39923 14.523 2.25208 14.2791 2.152ZM12.5001 15C14.1701 15 15.5231 13.657 15.5231 12C15.5231 10.343 14.1691 9 12.5001 9C10.8301 9 9.47707 10.343 9.47707 12C9.47707 13.657 10.8311 15 12.5001 15Z"
            fill="black"
          />
        </svg>
      );
    case NO_IMAGE:
      return (
        <svg width="80px" height="80px" viewBox="0 0 2.4 2.4" xmlns="http://www.w3.org/2000/svg">
          <path d="m0.783 0.5 -0.1 -0.1H2.2v1.517l-0.1 -0.1v-0.069l-0.312 -0.312 -0.04 0.03 -0.071 -0.071 0.085 -0.064a0.05 0.05 0 0 1 0.066 0.005L2.1 1.607V0.5zM0.3 2v-0.052l0.295 -0.295a0.15 0.15 0 0 0 0.068 0.016 0.14 0.14 0 0 0 0.1 -0.042l0.292 -0.292 -0.071 -0.071 -0.292 0.292a0.047 0.047 0 0 1 -0.068 -0.005 0.05 0.05 0 0 0 -0.07 0.001L0.3 1.807V0.583l-0.1 -0.1V2.1h1.617l-0.1 -0.1zM1.7 0.85A0.15 0.15 0 1 1 1.55 0.7 0.15 0.15 0 0 1 1.7 0.85m-0.1 0a0.05 0.05 0 1 0 -0.05 0.05 0.05 0.05 0 0 0 0.05 -0.05m0.565 1.385 0.071 -0.071 -2 -2 -0.071 0.071z" />
          <path fill="none" d="M0 0h2.4v2.4H0z" />
        </svg>
      );
    case ICON_TICK:
      return (
        <svg
          width="20px"
          height="20px"
          viewBox="0 0 0.4 0.4"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path width="16" height="16" id="icon-bound" fill="none" d="M0 0H0.4V0.4H0V0z" />
          <path d="M0 0.225 0.035 0.19l0.09 0.09L0.365 0.04l0.035 0.035L0.125 0.35z" />
        </svg>
      );
    case ICON_CLOSE:
      return (
        <svg
          width="20px"
          height="20px"
          viewBox="0 0 0.4 0.4"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#444"
            d="M0.378 0.078 0.323 0.023 0.2 0.148 0.078 0.023 0.023 0.078l0.125 0.123 -0.125 0.123 0.055 0.055 0.123 -0.125 0.123 0.125 0.055 -0.055 -0.125 -0.123z"
          />
        </svg>
      );
    case ICON_STATUS:
      return (
        <svg
          stroke="currentColor"
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 24 24"
          className=" text-xl text-secondary md:text-xs md:text-white"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="none"
            strokeWidth="2"
            d="M1,1 L23,1 M10,4.5 L14,4.5 C14,4.5 14,6 14,6 C14,7 12,8 12,8 C12,8 10,7 10,6 C10,6 10,4.5 10,4.5 Z M5,1 C5,1 5,3 5,6 C5,9 10,9.23530084 10,12 C10,14.7646992 5.00000001,15 5,18 C4.99999999,21 5,23 5,23 M19,1 C19,1 19,3 19,6 C19,9 14,9.23530084 14,12 C14,14.7646992 19,15 19,18 C19,21 19,23 19,23 M1,23 L23,23 M8,21 C8,19 12,17 12,17 C12,17 16,19 16,21 C16,21 16,23 16,23 L8,23 L8,21 Z"
          ></path>
        </svg>
      );
    case ICON_EDIT:
      return (
        <svg
          stroke="currentColor"
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 24 24"
          className="text-secondary"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path fill="none" d="M0 0h24v24H0z"></path>
          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 5.63l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41z"></path>
        </svg>
      );
    case ICON_VIEW:
      return (
        <svg
          stroke="currentColor"
          fill="none"
          strokeWidth="2"
          viewBox="0 0 24 24"
          stroke-linecap="round"
          stroke-linejoin="round"
          className="text-xl text-secondary"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
          <circle cx="12" cy="12" r="3"></circle>
        </svg>
      );

    case ICON_DELETE2:
      return (
        <svg
          stroke="currentColor"
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 24 24"
          className="cursor-pointer text-[23px] font-semibold text-secondary"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M5 20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8h2V6h-4V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3v2h2zM9 4h6v2H9zM8 8h9v12H7V8z"></path>
          <path d="M9 10h2v8H9zm4 0h2v8h-2z"></path>
        </svg>
      );
    case ICON_FILTER:
      return (
        <svg
          stroke="currentColor"
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 320 512"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"></path>
        </svg>
      );
    case ICON_BAG_ADDED:
      return (
        <svg
          stroke="currentColor"
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 16 16"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M10.5 3.5a2.5 2.5 0 0 0-5 0V4h5v-.5zm1 0V4H15v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4h3.5v-.5a3.5 3.5 0 1 1 7 0zm-.646 5.354a.5.5 0 0 0-.708-.708L7.5 10.793 6.354 9.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"
          ></path>
        </svg>
      );
    case ICON_DELETE_CONFIRM:
      return (
        <svg
          stroke="currentColor"
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 448 512"
          className="text-5xl text-secondary"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"></path>
        </svg>
      );
    case CHECKED_ICON:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="51"
          height="51"
          viewBox="0 0 51 51"
          fill="none"
        >
          <circle cx="25.5" cy="25.5" r="25" fill="#B06B5D" stroke="#4F4F4F" />
        </svg>
      );
    case UNCHECKED_ICON:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="51"
          height="51"
          viewBox="0 0 51 51"
          fill="none"
        >
          <circle cx="25.5" cy="25.5" r="25" fill="#EFE4D3" stroke="#4F4F4F" />
        </svg>
      );
    case ICON_DOWNLOAD:
      return (
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          enableBackground="new 0 0 32 32"
        >
          <line
            fill="none"
            stroke="#000000"
            strokeWidth="2"
            strokeMiterlimit="10"
            x1="25"
            y1="28"
            x2="7"
            y2="28"
          />
          <line
            fill="none"
            stroke="#000000"
            strokeWidth="2"
            strokeMiterlimit="10"
            x1="16"
            y1="23"
            x2="16"
            y2="4"
          />
          <polyline
            fill="none"
            stroke="#000000"
            strokeWidth="2"
            strokeMiterlimit="10"
            points="9,16 16,23 23,16 "
          />
        </svg>
      );
    case TRACKING_LOGO:
      return (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.33337 4.00008C1.33337 3.64646 1.47385 3.30732 1.7239 3.05727C1.97395 2.80722 2.31309 2.66675 2.66671 2.66675H17.3334C17.687 2.66675 18.0261 2.80722 18.2762 3.05727C18.5262 3.30732 18.6667 3.64646 18.6667 4.00008V10.6667H24C24.8755 10.6667 25.7424 10.8392 26.5513 11.1742C27.3601 11.5092 28.095 12.0003 28.7141 12.6194C29.3331 13.2384 29.8242 13.9734 30.1592 14.7822C30.4943 15.591 30.6667 16.4579 30.6667 17.3334V22.6667C30.6668 23.5251 30.391 24.3607 29.8798 25.0502C29.3687 25.7398 28.6493 26.2467 27.828 26.4961C27.5835 27.3027 27.0904 28.0115 26.4191 28.5213C25.7478 29.0311 24.9326 29.3157 24.0899 29.3346C23.2472 29.3536 22.42 29.1058 21.7265 28.6267C21.033 28.1476 20.5085 27.4616 20.228 26.6667H11.7734C11.4929 27.4616 10.9684 28.1476 10.2749 28.6267C9.5814 29.1058 8.75425 29.3536 7.91155 29.3346C7.06884 29.3157 6.25365 29.0311 5.58234 28.5213C4.91103 28.0115 4.41791 27.3027 4.17337 26.4961C3.35183 26.2469 2.6322 25.7401 2.1208 25.0506C1.60939 24.361 1.33332 23.5252 1.33337 22.6667V17.3334H9.33337C9.687 17.3334 10.0261 17.1929 10.2762 16.9429C10.5262 16.6928 10.6667 16.3537 10.6667 16.0001C10.6667 15.6465 10.5262 15.3073 10.2762 15.0573C10.0261 14.8072 9.687 14.6667 9.33337 14.6667H1.33337V12.0001H6.66671C7.02033 12.0001 7.35947 11.8596 7.60952 11.6096C7.85956 11.3595 8.00004 11.0204 8.00004 10.6667C8.00004 10.3131 7.85956 9.97399 7.60952 9.72394C7.35947 9.47389 7.02033 9.33341 6.66671 9.33341H1.33337V4.00008ZM18.6667 24.0001H20.228C20.4916 23.254 20.9706 22.6029 21.6043 22.1291C22.238 21.6552 22.998 21.38 23.7882 21.3382C24.5783 21.2964 25.3631 21.4898 26.0433 21.8941C26.7235 22.2984 27.2685 22.8953 27.6094 23.6094C27.7334 23.4858 27.8317 23.3388 27.8988 23.1771C27.9658 23.0153 28.0002 22.8419 28 22.6667V17.3334C28 16.2725 27.5786 15.2551 26.8285 14.505C26.0783 13.7548 25.0609 13.3334 24 13.3334H18.6667V24.0001ZM9.33337 25.3334C9.33337 24.9798 9.1929 24.6407 8.94285 24.3906C8.6928 24.1406 8.35366 24.0001 8.00004 24.0001C7.64642 24.0001 7.30728 24.1406 7.05723 24.3906C6.80718 24.6407 6.66671 24.9798 6.66671 25.3334C6.66671 25.687 6.80718 26.0262 7.05723 26.2762C7.30728 26.5263 7.64642 26.6667 8.00004 26.6667C8.35366 26.6667 8.6928 26.5263 8.94285 26.2762C9.1929 26.0262 9.33337 25.687 9.33337 25.3334ZM23.0574 24.3907C22.9332 24.5143 22.8347 24.6612 22.7677 24.823C22.7006 24.9848 22.6663 25.1583 22.6667 25.3334C22.6666 25.6419 22.7735 25.9408 22.9692 26.1793C23.1648 26.4178 23.4371 26.5811 23.7397 26.6414C24.0422 26.7016 24.3563 26.6551 24.6283 26.5097C24.9004 26.3643 25.1137 26.1291 25.2318 25.8442C25.3499 25.5592 25.3655 25.2421 25.276 24.9469C25.1865 24.6517 24.9974 24.3966 24.741 24.2252C24.4845 24.0538 24.1766 23.9766 23.8696 24.0068C23.5626 24.037 23.2755 24.1727 23.0574 24.3907Z"
            fill="#3065A1"
          />
        </svg>
      );
    case MEASUREMENT_ICON:
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
          <path d="M6.25 12.4738C6.25 13.8688 8.4875 15 11.25 15V12.4738C11.25 11.2313 11.25 10.6088 10.7537 10.23C10.2562 9.85129 9.76375 9.99254 8.77875 10.2763C7.26875 10.7125 6.25 11.5313 6.25 12.4738Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M20 10.625C20 13.0412 16.0825 15 11.25 15C6.4175 15 2.5 13.0412 2.5 10.625C2.5 8.20875 6.4175 6.25 11.25 6.25C16.0825 6.25 20 8.20875 20 10.625Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M2.5 11.25V19.5837C2.5 21.8837 6.4175 23.75 11.25 23.75H25C26.1788 23.75 26.7675 23.75 27.1338 23.3838C27.5 23.0175 27.5 22.4288 27.5 21.25V17.5C27.5 16.3212 27.5 15.7325 27.1338 15.3663C26.7675 15 26.1788 15 25 15H11.25M22.5 23.75V21.25M17.5 23.75V21.25M12.5 23.75V21.25M7.5 23.125V20.625" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      );
    case INFO_ICON:
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 17C11.45 17 11 16.55 11 16V12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12V16C13 16.55 12.55 17 12 17ZM13 9H11V7H13V9Z" fill="black" />
        </svg>
      );
    case INFO_ICON_WHITE:
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 17C11.45 17 11 16.55 11 16V12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12V16C13 16.55 12.55 17 12 17ZM13 9H11V7H13V9Z" fill="white" />
        </svg>
      );
    case ICON_VIDEO_UPLOAD:
      return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_3_352)">
            <path d="M25.9961 13.9992H3.99609C1.79609 13.9992 0 15.7953 0 18.0039V40.0039C0 42.2039 1.79609 44 3.99609 44H25.9961C28.2047 44 29.9922 42.2039 29.9922 40.0039V18.0039C30.0008 15.7953 28.2047 13.9992 25.9961 13.9992ZM32.0031 24.0023V34.0055L44 40.0039V18.0039L32.0031 24.0023ZM5.99844 11.9969C9.31563 11.9969 11.9969 9.30703 11.9969 5.99844C11.9969 2.68984 9.31563 0 5.99844 0C2.68984 0 0 2.68984 0 5.99844C0 9.30703 2.68984 11.9969 5.99844 11.9969ZM24.0023 0C20.6852 0 18.0039 2.68984 18.0039 5.99844C18.0039 9.30703 20.6937 11.9969 24.0023 11.9969C27.3195 11.9969 30.0008 9.30703 30.0008 5.99844C30.0008 2.68984 27.3109 0 24.0023 0Z" fill="#4B5563" />
          </g>
          <defs>
            <clipPath id="clip0_3_352">
              <rect width="44" height="44" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case ICON_TAG_UPLOAD:
      return (
        <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.04222 26.4381C1.72384 28.8202 3.55972 30.6537 7.22909 34.3231L11.5753 38.6693C17.9641 45.0604 21.1561 48.2501 25.1223 48.2501C29.091 48.2501 32.283 45.0581 38.6693 38.6717C45.0581 32.2829 48.2501 29.0909 48.2501 25.1223C48.2501 21.1561 45.0581 17.9617 38.6717 11.5753L34.3255 7.22905C30.6537 3.55967 28.8202 1.7238 26.4381 1.04217C24.056 0.358174 21.5266 0.942424 16.4702 2.11092L13.5537 2.78305C9.29772 3.76392 7.16972 4.25555 5.71147 5.71142C4.25322 7.1673 3.76634 9.30005 2.78309 13.5537L2.10859 16.4702C0.94247 21.5289 0.360594 24.0559 1.04222 26.4381ZM20.0398 13.2687C20.4979 13.7104 20.8634 14.239 21.1149 14.8236C21.3664 15.4082 21.4989 16.037 21.5047 16.6734C21.5104 17.3098 21.3894 17.9409 21.1485 18.53C20.9076 19.119 20.5518 19.6541 20.1018 20.1041C19.6518 20.5541 19.1167 20.91 18.5276 21.1508C17.9386 21.3917 17.3074 21.5128 16.6711 21.507C16.0347 21.5012 15.4059 21.3687 14.8213 21.1172C14.2367 20.8657 13.7081 20.5003 13.2663 20.0422C12.3948 19.1385 11.9129 17.9288 11.9243 16.6734C11.9357 15.418 12.4395 14.2173 13.3272 13.3295C14.2149 12.4418 15.4157 11.938 16.6711 11.9267C17.9265 11.9153 19.1362 12.3972 20.0398 13.2687ZM41.2438 24.6212L24.6687 41.1987C24.3326 41.523 23.8826 41.7023 23.4155 41.698C22.9485 41.6938 22.5018 41.5062 22.1717 41.1758C21.8416 40.8454 21.6545 40.3985 21.6507 39.9315C21.6468 39.4645 21.8266 39.0146 22.1512 38.6788L38.724 22.1013C39.0581 21.7671 39.5113 21.5794 39.9839 21.5794C40.4565 21.5794 40.9097 21.7671 41.2438 22.1013C41.578 22.4355 41.7657 22.8887 41.7657 23.3612C41.7657 23.8338 41.578 24.287 41.2438 24.6212Z" fill="#4B5563" />
        </svg>
      );
    case ICON_RECIEPT_UPLOAD:
      return (
        <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M50.0828 3.35914C49.6908 3.26593 49.2784 3.31624 48.9203 3.50096L46.3749 4.77213L43.8077 3.48854C43.5777 3.37356 43.3242 3.3137 43.0671 3.3137C42.8099 3.3137 42.5564 3.37356 42.3264 3.48854L39.7271 4.77316L37.162 3.48854C36.9314 3.37272 36.6768 3.31241 36.4188 3.31241C36.1607 3.31241 35.9062 3.37272 35.6755 3.48854L33.1249 4.76902L30.5939 3.49164C30.3639 3.37503 30.1098 3.31374 29.8519 3.31266C29.5941 3.31159 29.3395 3.37075 29.1085 3.48543L26.4999 4.7742L23.9327 3.4875C23.7023 3.37258 23.4484 3.31276 23.191 3.31276C22.9336 3.31276 22.6797 3.37258 22.4493 3.4875L19.8749 4.77213L17.3036 3.4875C16.9721 3.32134 16.5944 3.27121 16.2311 3.34516C15.8677 3.41911 15.5397 3.61285 15.2995 3.89535C15.0406 4.20389 14.9011 4.59507 14.9061 4.99779V29.8126L14.9113 29.8177H34.7811C35.6597 29.8177 36.5022 30.1667 37.1234 30.7879C37.7446 31.4092 38.0936 32.2517 38.0936 33.1302V43.8907C38.0936 47.0924 41.5169 49.6876 44.7186 49.6876H45.9608C47.3884 49.6876 48.7576 49.1204 49.7671 48.111C50.7765 47.1015 51.3436 45.7324 51.3436 44.3047V4.96881C51.3439 4.59811 51.2199 4.23803 50.9913 3.94619C50.7627 3.65436 50.4428 3.44765 50.0828 3.35914ZM43.0624 24.8438H29.8641C28.9698 24.8438 28.1975 24.1565 28.1582 23.2621C28.1481 23.0386 28.1835 22.8153 28.2621 22.6058C28.3406 22.3964 28.4608 22.205 28.6154 22.0432C28.77 21.8815 28.9558 21.7527 29.1615 21.6647C29.3672 21.5767 29.5886 21.5314 29.8124 21.5313H43.0106C43.905 21.5313 44.6772 22.2187 44.7166 23.113C44.7266 23.3365 44.6913 23.5598 44.6127 23.7693C44.5341 23.9788 44.4139 24.1702 44.2593 24.3319C44.1048 24.4937 43.919 24.6224 43.7133 24.7104C43.5076 24.7984 43.2861 24.8438 43.0624 24.8438ZM43.0624 16.5626H23.2391C22.3448 16.5626 21.5725 15.8752 21.5332 14.9808C21.5231 14.7573 21.5585 14.5341 21.6371 14.3246C21.7156 14.1151 21.8358 13.9237 21.9904 13.762C22.145 13.6002 22.3308 13.4715 22.5365 13.3835C22.7422 13.2955 22.9636 13.2501 23.1874 13.2501H43.0106C43.905 13.2501 44.6772 13.9374 44.7166 14.8318C44.7266 15.0553 44.6913 15.2785 44.6127 15.488C44.5341 15.6975 44.4139 15.8889 44.2593 16.0507C44.1048 16.2124 43.919 16.3412 43.7133 16.4291C43.5076 16.5171 43.2861 16.5625 43.0624 16.5626Z" fill="#4B5563" />
          <path d="M34.7812 43.8906V34.7812C34.7812 34.342 34.6068 33.9207 34.2961 33.6101C33.9855 33.2995 33.5643 33.125 33.125 33.125H4.96875C4.09017 33.1277 3.24842 33.4783 2.62765 34.1001C2.00688 34.7218 1.65761 35.5641 1.65625 36.4427C1.65625 41.6754 2.25457 43.8513 3.15309 45.5075C4.67787 48.3201 7.43863 49.6875 11.5937 49.6875H37.0255C37.1072 49.6876 37.187 49.6635 37.2551 49.6182C37.3231 49.573 37.3762 49.5086 37.4078 49.4333C37.4393 49.3579 37.4478 49.2749 37.4323 49.1947C37.4168 49.1145 37.3779 49.0407 37.3205 48.9826C36.3412 48.0002 34.7812 46.6855 34.7812 43.8906Z" fill="#4B5563" />
        </svg>
      );
    case INFO_ICON_SQUARE:
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M4 4.00098H20V18.001C20 18.5314 19.7893 19.0401 19.4142 19.4152C19.0391 19.7903 18.5304 20.001 18 20.001H6C5.46957 20.001 4.96086 19.7903 4.58579 19.4152C4.21071 19.0401 4 18.5314 4 18.001V4.00098Z" stroke="#B06B5D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none" />
          <path d="M12 16H12.01V16.01H12V16Z" stroke="#B06B5D" stroke-width="2.25" stroke-linejoin="round" />
          <path d="M12 12V8" stroke="#B06B5D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      );
      case ICON_CONTACT_USER:
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M12.0002 2C12.7074 2 13.3857 2.28095 13.8858 2.78105C14.3859 3.28115 14.6668 3.95942 14.6668 4.66667V10C14.6668 10.7072 14.3859 11.3855 13.8858 11.8856C13.3857 12.3857 12.7074 12.6667 12.0002 12.6667H8.85083L5.67616 14.5713C5.58056 14.6287 5.47208 14.6612 5.36068 14.6658C5.24927 14.6704 5.13849 14.647 5.03847 14.5977C4.93845 14.5484 4.85239 14.4749 4.78816 14.3837C4.72393 14.2926 4.68359 14.1868 4.67083 14.076L4.66683 14V12.6667H4.00016C3.316 12.6667 2.65801 12.4037 2.16229 11.9322C1.66657 11.4607 1.37104 10.8166 1.33683 10.1333L1.3335 10V4.66667C1.3335 3.95942 1.61445 3.28115 2.11454 2.78105C2.61464 2.28095 3.29292 2 4.00016 2H12.0002ZM9.3335 8H5.3335C5.15668 8 4.98712 8.07024 4.86209 8.19526C4.73707 8.32029 4.66683 8.48986 4.66683 8.66667C4.66683 8.84348 4.73707 9.01305 4.86209 9.13807C4.98712 9.26309 5.15668 9.33333 5.3335 9.33333H9.3335C9.51031 9.33333 9.67988 9.26309 9.8049 9.13807C9.92992 9.01305 10.0002 8.84348 10.0002 8.66667C10.0002 8.48986 9.92992 8.32029 9.8049 8.19526C9.67988 8.07024 9.51031 8 9.3335 8ZM10.6668 5.33333H5.3335C5.15668 5.33333 4.98712 5.40357 4.86209 5.5286C4.73707 5.65362 4.66683 5.82319 4.66683 6C4.66683 6.17681 4.73707 6.34638 4.86209 6.4714C4.98712 6.59643 5.15668 6.66667 5.3335 6.66667H10.6668C10.8436 6.66667 11.0132 6.59643 11.1382 6.4714C11.2633 6.34638 11.3335 6.17681 11.3335 6C11.3335 5.82319 11.2633 5.65362 11.1382 5.5286C11.0132 5.40357 10.8436 5.33333 10.6668 5.33333Z" fill="#374151"/>
      </svg>
      );
    default:
      return <></>;
  }
};

IconCollection.defaultProps = {
  className: null,
  rootClassName: null,
  brand: 'default',
};

IconCollection.propTypes = {
  className: string,
  rootClassName: string,
  brand: string,
};

export default IconCollection;
